import type { LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

const DANGER_CLASS = 'text-destructive hover:bg-destructive/10 hover:text-destructive';

interface IconTooltipButtonProps {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  isDisabled?: boolean | undefined;
  isDanger?: boolean | undefined;
  hasTooltip?: boolean | undefined;
}

export function IconTooltipButton({
  icon: Icon,
  label,
  onClick,
  isDisabled = false,
  isDanger = false,
  hasTooltip = true,
}: IconTooltipButtonProps) {
  const buttonProps = {
    type: 'button',
    variant: 'ghost',
    size: 'icon-sm',
    disabled: isDisabled,
    onClick,
    'aria-label': label,
    className: cn(isDanger && DANGER_CLASS),
  } as const;
  const icon = <Icon className="size-3.5" aria-hidden />;

  if (!hasTooltip) return <Button {...buttonProps}>{icon}</Button>;

  return (
    <Tooltip>
      <TooltipTrigger render={<Button {...buttonProps} />}>{icon}</TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
